import Tabs from './Tabs';
import Container from '../elements/container';
import PageHeading from '../elements/page-heading';
import Button from '../elements/button';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Choice() {
  const navigate = useNavigate();

  useEffect(() => {
    return () => sessionStorage.clear();
  }, []);

  return (
    <>
      <Tabs />
      <Container className="flex flex-col items-center gap-y-4 sm:gap-y-7 mb-16 px-4 sm:px-6">
        <PageHeading title="Bitte wählen Sie, an welchem Punkt Sie starten möchten" />
        <Button size="lg" onClick={() => navigate('/diagnostics-results')} className="w-full sm:w-4/5 md:w-3/5 lg:w-3/5">
          Diagnostikempfehlung
        </Button>
        <Button size="lg" onClick={() => navigate('/promotion-test')} className="w-full sm:w-4/5 md:w-3/5 lg:w-3/5">
          Förderempfehlung
        </Button>
      </Container>
    </>
  );
}
export default Choice;
